import React from 'react'
import BaseButton from '../../../base_button'
import Loader from '../../../../../base/loader'
import { css } from 'aphrodite'
import {
  baseStyles,
  condensedStyles,
  fullWidthStyles,
  loadingIconStyles,
  contentStyles
} from '../../../styles'
import { styles } from '../../styles'
import PropTypes from 'prop-types'

const SecondaryCondensedLightButton = ({
  type,
  disabled,
  onClick,
  className,
  href,
  element,
  children,
  loading,
  fullWidth
}) => {
  const getContent = () => {
    if (loading) {
      return (
        <span className={css(contentStyles.base, contentStyles.loading)}>
          <Loader
            width={loadingIconStyles.width}
            height={loadingIconStyles.height}
            foregroundColour={loadingIconStyles.lightTheme.foregroundColor}
            backgroundColour={loadingIconStyles.lightTheme.backgroundColor}
          />
        </span>
      )
    }
    return <span className={css(contentStyles.base)}>{children}</span>
  }

  return (
    <BaseButton
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={
        css(
          baseStyles.base,
          styles.base,
          condensedStyles.condensed,
          styles.lightBase,
          fullWidth && fullWidthStyles.fullWidth,
          disabled && styles.disabled,
          className
        )
      }
      href={href}
      element={element}
    >
      {getContent()}
    </BaseButton>
  )
}

SecondaryCondensedLightButton.defaultProps = {
  type: 'button',
  disabled: false,
  element: 'button',
  loading: false,
  fullWidth: false
}

SecondaryCondensedLightButton.propTypes = {
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.any,
  href: PropTypes.string,
  element: PropTypes.oneOf(['a', 'button']),
  children: PropTypes.any,
  loading: PropTypes.bool,
  fullWidth: PropTypes.bool
}

export default SecondaryCondensedLightButton
